import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import { useAuth } from '../../context/AuthContext/AuthContext'
import { useNavigate } from 'react-router-dom'

const LogoutPage = () => {
  const { logout } = useAuth()
  const navigate = useNavigate()

  function handleLogout() {
    logout()
    navigate('/')
  }

  return (
    <Box>
      <Typography variant="h1">Logout</Typography>
      <Button onClick={handleLogout}>Logout</Button>
    </Box>
  )
}

export default LogoutPage
